// Utility Function: Converts meters to feet
function metersToFeet(meters) {
    return meters * 3.28084; // 1 meter = 3.28084 feet
}

// Room Scalar Values for BTU Calculation
const roomScalar = {
    "kitchen": 3,
    "bathroom": 3.7,
    "bedroom": 3.1,
    "dining-room": 4,
    "hallway": 3,
    "lounge": 3.7
};

// Optional Parameter Scalar Values for BTU Calculation
const paramScalar = {
    "glazed": 0.9,
    "french": 1.2
};

// Function: Calculate BTU based on room dimensions, room type, and optional parameters
function calculateBTU(length, width, height, roomType, optionalParams = []) {
    // Calculate room volume in cubic feet
    const volume = length * width * height;

    // Calculate BTU based on room type and volume
    let BTU = volume * roomScalar[roomType];

    // Apply optional parameter scalars
    for (const param of optionalParams) {
        BTU *= paramScalar[param];
    }

    return BTU;
}

// HTML Elements Declaration
const form = document.getElementById("btu-calculator");
const result = document.getElementById("result");
const calculateButton = document.getElementById('CalculateButton');
const resetButton = document.querySelector('button[type="reset"]');
const radioButtons = document.querySelectorAll('input[name="length-unit"]');
const inputIndicators = document.querySelectorAll('.input-indicator');

// Function: Check if all fields are valid
function areAllFieldsValid() {
    // Validate input fields and room type selection
    const lengthInput = parseFloat(document.getElementById("length").value);
    const widthInput = parseFloat(document.getElementById("width").value);
    const heightInput = parseFloat(document.getElementById("height").value);
    const roomType = document.getElementById("room-type-selector").value;

    return (
        !isNaN(lengthInput) && lengthInput > 0 &&
        !isNaN(widthInput) && widthInput > 0 &&
        !isNaN(heightInput) && heightInput > 0 &&
        roomType !== ""
    );
}

// Function: Enable or disable the button based on field validity
function updateButtonState() {
    calculateButton.disabled = !areAllFieldsValid();
}

// Event Listeners for Input Fields
const inputFields = document.querySelectorAll('input[type="number"], select, input[type="checkbox"]');
inputFields.forEach((input) => {
    input.addEventListener("input", updateButtonState);
});

// Add a click event listener to the reset button
resetButton.addEventListener('click', function () {
    calculateButton.disabled = true;
    // Update the input indicators' text based on the selected radio button
    inputIndicators.forEach(inputIndicator => inputIndicator.textContent = 'm');
});

// Initial state of the button
updateButtonState();

// Add an event listener to each radio button
radioButtons.forEach((radioButton) => {
    radioButton.addEventListener('change', (event) => {
        // Update the input indicators' text based on the selected radio button
        inputIndicators.forEach(inputIndicator => inputIndicator.textContent = event.target.value);
    });
});

// Event Listener for Form Submission
form.addEventListener("submit", function (event) {
    event.preventDefault();

    // Get input values
    const lengthInput = parseFloat(document.getElementById("length").value);
    const widthInput = parseFloat(document.getElementById("width").value);
    const heightInput = parseFloat(document.getElementById("height").value);
    const roomType = document.getElementById("room-type-selector").value;

    // Get the IDs of checked checkboxes as optional parameters
    const optionalParams = Array.from(document.querySelectorAll('input[type="checkbox"]:checked')).map(checkbox => checkbox.id);

    // Get the selected length unit ("m" or "ft")
    const lengthUnit = document.querySelector('input[name="length-unit"]:checked').value;

    // Convert dimensions to feet if the unit is "meters"
    const length = (lengthUnit === "m") ? metersToFeet(lengthInput) : lengthInput;
    const width = (lengthUnit === "m") ? metersToFeet(widthInput) : widthInput;
    const height = (lengthUnit === "m") ? metersToFeet(heightInput) : heightInput;

    // Define the BTU threshold for multiple heaters
    const BTUThreshold = 10000;

    // Calculate BTU
    const BTU = Math.trunc(calculateBTU(length, width, height, roomType, optionalParams));

    // Construct the search URL
    const searchURL = new URL("https://www.epicradiators.co.uk/?q=radiator");

    searchURL.searchParams.set("btu", BTU.toString());

    const urlString = searchURL.toString();

    // Construct the result message with strong text, a paragraph, and a link
    let resultMessage = `
    <strong>Required BTU:</strong> ${BTU} BTU<br>
    <p>This is the calculated BTU for your room. Bear in mind that this is just an estimate and your room may require more than this depending on other variables.</p>
    `;

    // Check if BTU is over the threshold
    if (BTU > BTUThreshold) {
        resultMessage += "<p class='over-threshold'>You may need more than one radiator to heat this room.</p>";
    }

    resultMessage += `<div class="result-links"><a href="${urlString}" style="display:none;">See suitable products</a><a href="https://www.epicradiators.co.uk/collections/btu-500-2500" class="button button--secondary">View Radiators with BTU 500 to 2500</a>
<a href="https://www.epicradiators.co.uk/collections/btu-2501-5000" class="button button--secondary">View Radiators with BTU 2501 to 5000</a>
<a href="https://www.epicradiators.co.uk/collections/bbtu-5001-7500" class="button button--secondary">View Radiators with BTU 5001 to 7500</a>
<a href="https://www.epicradiators.co.uk/collections/btu-7501-10000" class="button button--secondary">View Radiators with BTU 7501 to 10000</a></div>`


    // Set the resultMessage as innerHTML
    result.innerHTML = resultMessage;

    result.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
});

/**
 * ACCESSIBLE CUSTOM RADIOS FIX
 */

// Get all the div elements with role="radio"
const radioDivs = document.querySelectorAll('[role="radio"]');

// Loop through each div and add event listeners
radioDivs.forEach((divElement) => {
    // Add keydown event listener
    divElement.addEventListener('keydown', (event) => {
        if (event.key === ' ') { // Check for space key
            // Find the associated radio input within this div
            const radioInput = divElement.querySelector('input[type="radio"]');

            // Check the radio input
            radioInput.checked = true;
        }
    });
});